/**
 * Landers then offers, stacked (shared list + detail layouts).
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import type { VoluumPathUpdate } from '@trafficpulse/shared';

import { PathItemsSection } from './path-items';

export interface PathLandersOffersGridProps {
  path: VoluumPathUpdate;
  onPatch: (mutator: (p: VoluumPathUpdate) => void) => void;
}

const PathLandersOffersGrid: FC<PathLandersOffersGridProps> = ({
  path,
  onPatch,
}) => (
  <div className="flex flex-col gap-2">
    <PathItemsSection kind="landers" path={path} onPatch={onPatch} />
    <PathItemsSection kind="offers" path={path} onPatch={onPatch} />
  </div>
);

export default PathLandersOffersGrid;
